import ReplayOutlinedIcon from '@mui/icons-material/ReplayOutlined';
import { Button, SxProps, Theme, useTheme } from '@mui/material';
import React from 'react';

interface IProps {
  onClick: () => void;
  label?: string;
  dataAction?: string;
  sx?: SxProps<Theme>;
}

export const ResetButton: React.FC<IProps> = ({ onClick, label = 'Reset to default', dataAction, sx }) => {
  const theme = useTheme();

  return (
    <Button
      variant="text"
      onClick={onClick}
      startIcon={<ReplayOutlinedIcon sx={{ width: 18, height: 18, color: theme.palette.action.active }} />}
      sx={{
        height: 24,
        minWidth: 140,
        alignItems: 'center',
        color: theme.palette.text.primary,
        '&:hover': {
          backgroundColor: 'transparent',
        },
        ...sx,
      }}
      data-action={dataAction}
    >
      {label}
    </Button>
  );
};
